import React from "react";
import { Terminal, Copy } from "lucide-react";
import Footer from "../components/Footer";

const CodeBlock = ({ title, code }) => {
  return (
    <div className="bg-slate-50 border border-slate-200 rounded-2xl p-5 md:p-6 shadow-sm">
      <div className="flex items-center justify-between gap-3 mb-3">
        <h3 className="text-sm md:text-base font-semibold text-slate-900">
          {title}
        </h3>
        <div className="inline-flex items-center gap-1 text-xs text-slate-500">
          <Copy className="w-3.5 h-3.5" />
          Copy
        </div>
      </div>
      <pre className="overflow-x-auto text-xs md:text-sm bg-slate-900 text-slate-100 rounded-xl p-4">
        <code>{code}</code>
      </pre>
    </div>
  );
};

const CLI = () => {
  return (
    <>
      <main className="page cli-page min-h-[80vh] py-16 px-6 md:px-16 bg-white">
        <section className="max-w-5xl mx-auto">
          <div className="mb-12">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-violet-50 text-violet-700 text-xs font-semibold mb-3">
              <span className="w-1.5 h-1.5 rounded-full bg-violet-500" />
              CLI Tool Installation
            </div>
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2.5 rounded-full bg-violet-100">
                <Terminal className="w-5 h-5 text-violet-700" />
              </div>
              <h1 className="text-3xl md:text-4xl font-bold text-slate-900">
                Origenomi <span className="text-violet-700">CLI</span>
              </h1>
            </div>
            <p className="text-sm md:text-base leading-relaxed text-slate-700 max-w-3xl">
              Origenomi is the command-line tool behind Origenomi’s genome
              re-organization workflow. Use it to run the pipeline on a FASTA
              input and write outputs to a directory of your choice.
            </p>
          </div>

          <div className="space-y-10">
            <div>
              <h2 className="text-xl md:text-2xl font-semibold text-slate-900 mb-3">
                Install (editable)
              </h2>
              <p className="text-sm md:text-base leading-relaxed text-slate-700 mb-4">
                From the repository root, the CLI lives in{" "}
                <span className="font-mono text-slate-900">
                  origenomi-cli
                </span>
                .
              </p>
              <CodeBlock
                title="Install the CLI"
                code={`cd origenomi-cli\npip install -e .\norigenomi -h`}
              />
            </div>

            <div>
              <h2 className="text-xl md:text-2xl font-semibold text-slate-900 mb-3">
                Usage
              </h2>
              <div className="grid md:grid-cols-2 gap-6">
                <CodeBlock
                  title="Help"
                  code={`origenomi -h`}
                />
                <CodeBlock
                  title="Run with input + output"
                  code={`origenomi -i genome.fna -o ./out`}
                />
                <CodeBlock
                  title="Keep plots (optional)"
                  code={`origenomi -i genome.fna -o ./out --keep-temp`}
                />
                <div className="bg-gradient-to-br from-violet-50 to-slate-50 border border-slate-200 rounded-2xl p-6 shadow-sm">
                  <h3 className="text-sm md:text-base font-semibold text-slate-900 mb-2">
                    Flags
                  </h3>
                  <ul className="list-disc pl-5 space-y-1 text-sm md:text-base leading-relaxed text-slate-700">
                    <li>
                      <span className="font-mono text-slate-900">-h</span>{" "}
                      Show help.
                    </li>
                    <li>
                      <span className="font-mono text-slate-900">-i</span>{" "}
                      Input FASTA file.
                    </li>
                    <li>
                      <span className="font-mono text-slate-900">-o</span>{" "}
                      Output directory.
                    </li>
                    <li>
                      <span className="font-mono text-slate-900">
                        --keep-temp
                      </span>{" "}
                      Keep temporary files (and plots).
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-slate-900 text-slate-100 rounded-2xl p-7 md:p-8">
              <h2 className="text-lg md:text-xl font-semibold mb-2">
                Tip: Prefer the web UI?
              </h2>
              <p className="text-sm md:text-base text-slate-200 leading-relaxed">
                You can always run analysis directly in the browser via the
                “Start Genome Analysis” card on the home page, and use the CLI
                when you need automation or batch processing.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default CLI;


